import styled, { withTheme } from 'styled-components';

const WysiwygEditor = styled.div`
div {
    text-align:left;
    margin:0 0 15px 0;
    padding:15px;
    border: 2px dotted ${(props) => props.theme.$gold};
    &:focus {
        outline:0;
        border: 2px solid ${(props) => props.theme.$black};
    }
    ul {
        margin:0;
        padding:0 0 0 1rem;
    }
    
}
`;

export default withTheme(WysiwygEditor);
